import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class PresetsService extends BaseService {
  static get entity() {
    return 'presets'
  }

  static async getList() {
    try {
      const response = await this.request({ auth: true }).get(`applications/${this.entity}/list`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async create(payload) {
    try {
      const response = await this.request({ auth: true }).post(`applications/${this.entity}/new`, {
        ...payload,
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async delete({ id }) {
    try {
      const response = await this.request({ auth: true }).delete(
        `applications/${this.entity}/${id}`
      )

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
